import './field.scss';

import * as gzFieldDirective from './field.directive';
import $gzFields from '../fields.module';

export default angular.module('gazelle.components.field', [
  $gzFields
])
  .directive(gzFieldDirective.name, gzFieldDirective.default)
  .name;
